export const INPUT_ACTION_KEY = "INPUT_ACTION_KEY";
